import React from "react";
import {
  defineBlock,
  smartProps,
  useInspectorControl,
  BlockWrapper,
} from "@smartfire/js-block-engine";
import useMediaQuery from "@mui/material/useMediaQuery";
import style from "./style.module.scss";
import clsx from "clsx";

const Inspector = React.lazy(() => import("./inspector.js"));

function Block({ height, tabletHeight, mobileHeight, hasDivider }) {
  useInspectorControl(Inspector);
  const isMobile = useMediaQuery("(max-width: " + style.mobileBreakpoint + ")");
  const isTablet = useMediaQuery("(max-width: " + style.tabletBreakpoint + ")");
  const spacerHeight = isMobile
    ? mobileHeight
    : isTablet
    ? tabletHeight
    : height;

  return (
    <BlockWrapper.Div
      className={clsx(style.block, hasDivider && style.dividerWrapper)}
      style={{
        height: spacerHeight + "px",
      }}
    >
      {hasDivider && <div className={style.divider} />}
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    height: smartProps.number.withDefault(50),
    tabletHeight: smartProps.number.withDefault(30),
    mobileHeight: smartProps.number.withDefault(30),
    hasDivider: smartProps.bool.withDefault(false),
  },
  setup: {
    title: "Spacer",
  },
});
